import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
// Auto-dismisses flash messages after a timeout (zero: never)
export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 5000 },
  }

  declare timeoutValue: number
  private timeoutId: ReturnType<typeof setTimeout> | null = null

  connect() {
    // A zero timeout means the message is the page's own state — what the
    // listener has to do next after paying — and only they may end it (#2002).
    if (this.timeoutValue <= 0) return

    this.timeoutId = setTimeout(() => {
      this.dismiss()
    }, this.timeoutValue)
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  dismiss() {
    this.element.classList.add("animate-out", "fade-out", "slide-out-to-top-2")
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
